import { WebPlugin } from '@capacitor/core';
import { KeyManager } from './key-manager';
import { IdbKeyStore } from './idb-key-store';
export class KeyManagerWeb extends WebPlugin {
    constructor() {
        super();
        this.impl = new KeyManager;
        this.impl.useKeyStore(new IdbKeyStore);
    }
    async checkAliasExists(options) {
        return this.impl.checkAliasExists(options);
    }
    async generateKey(options) {
        return this.impl.generateKey(options);
    }
    async generateRecoverableSignatureKeyPair(options) {
        return this.impl.generateRecoverableSignatureKeyPair(options);
    }
    async generateRecoverableAgreementKeyPair(options) {
        return this.impl.generateRecoverableAgreementKeyPair(options);
    }
    async generateRecoverableKey(options) {
        return this.impl.generateRecoverableKey(options);
    }
    async rewrapSignatureKeyPair(options) {
        return this.impl.rewrapSignatureKeyPair(options);
    }
    async rewrapAgreementKeyPair(options) {
        return this.impl.rewrapAgreementKeyPair(options);
    }
    async rewrapKey(options) {
        return this.impl.rewrapKey(options);
    }
    async recoverSignatureKeyPair(options) {
        return this.impl.recoverSignatureKeyPair(options);
    }
    async recoverAgreementKeyPair(options) {
        return this.impl.recoverAgreementKeyPair(options);
    }
    async recoverKey(options) {
        return this.impl.recoverKey(options);
    }
    async importPublicAgreementKey(options) {
        return this.impl.importPublicAgreementKey(options);
    }
    async importPublicSignatureKey(options) {
        return this.impl.importPublicSignatureKey(options);
    }
    async encrypt(options) {
        return this.impl.encrypt(options);
    }
    async decrypt(options) {
        return this.impl.decrypt(options);
    }
    async sign(options) {
        return this.impl.sign(options);
    }
    async verify(options) {
        return this.impl.verify(options);
    }
}
//# sourceMappingURL=web.js.map